import React, { useState } from "react";
import "../styles/TablesShelppanel.css";
import { useGame } from "../GameContext";

const Helppanel: React.FC = () => {
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="tableS-helpPanel" id="tableS-helpPanel">
      <img
        src="/img/close.svg"
        id="hotel-closeButton"
        alt="Закрыть"
        className="tableS-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="tableS-helpPivots">
        <div
          className="tableS-selectPivots"
          id={showhelpPivots === "pivotTask" ? "tableS-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="tableS-commandsCards">
          <div className="tableS-helpCard">
            <div className="tableS-cardCaption">Суть игры</div>
            <div>
              <div>
                123123!!!!
              </div>
            </div>
          </div>
          <div className="tableS-helpCard">
            <div className="tableS-cardCaption">Правила игры</div>
            <div>
              <div>
                123123123!!!!
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
